import { creditBalanceSchema } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import type { z } from "zod";

import { axios } from "@/client/libs/axios";

export type CreditBalance = z.infer<typeof creditBalanceSchema>;

const getMyBalance =
  async (): Promise<CreditBalance> => {
    const response =
      await axios.get<unknown>(
        "/credit/balance/me",
      );

    return creditBalanceSchema.parse(response.data);
  };

export const useCrBalance = (
  userId?: string,
) => {
  const {
    data: credit,
    error,
    isPending: loading,
    isFetching: refreshing,
    refetch,
  } = useQuery({
    /*
     * userId reste dans la clé pour isoler
     * correctement le cache entre deux comptes.
     */
    queryKey: [
      "balance-credit",
      userId,
    ],

    /*
     * L’identifiant n’est plus envoyé dans
     * l’URL : le backend utilise la session.
     */
    queryFn: getMyBalance,

    enabled: Boolean(userId),
    staleTime: 30_000,
  });

  return {
    /*
     * Contrat existant conservé.
     */
    credit,
    error,

    /*
     * Propriétés ajoutées pour les nouveaux
     * dialogues CV et IA.
     */
    loading,
    refreshing,
    refetch,
    remainingCredits: Number(
      credit?.credit ?? 0,
    ),
  };
};